import { apiClient } from './apiClient';

/**
 * CallAgentService - wrapper for call agent template API operations
 */
export class CallAgentService {
    constructor() {
        this.BASE = '/call-agent-templates';
    }

    async getAllTemplates() {
        try {
            const res = await apiClient.get(this.BASE);
            return Array.isArray(res) ? res : res?.data || res;
        } catch (error) {
            console.error('callAgentService.getAllTemplates error', error);
            throw error;
        }
    }

    async getTemplateById(id) {
        if (!id) throw new Error('Template id is required');
        try {
            return await apiClient.get(`${this.BASE}/${id}`);
        } catch (error) {
            console.error('callAgentService.getTemplateById error', error);
            throw error;
        }
    }

    async createTemplate(template) {
        try {
            return await apiClient.post(this.BASE, template);
        } catch (error) {
            console.error('callAgentService.createTemplate error', error);
            throw error;
        }
    }

    /**
     * Backend route expects POST /call-agent-templates/update with body containing _id
     * Accepts either (id, template) or a template object that includes _id
     */
    async updateTemplate(idOrTemplate, maybeTemplate) {
        const payload = typeof idOrTemplate === 'string' ? { _id: idOrTemplate, ...(maybeTemplate || {}) } : (idOrTemplate || {});
        if (!payload._id) throw new Error('Template _id is required for update');
        try {
            return await apiClient.post(`${this.BASE}/update`, payload);
        } catch (error) {
            console.error('callAgentService.updateTemplate error', error);
            throw error;
        }
    }

    async deleteTemplate(id) {
        if (!id) throw new Error('Template id is required');
        try {
            return await apiClient.delete(`${this.BASE}/${id}`);
        } catch (error) {
            console.error('callAgentService.deleteTemplate error', error);
            throw error;
        }
    }
}

export const callAgentService = new CallAgentService();